// Abrir o documento tecnico de um layout numa aba.
//
// Existe por um motivo bem chato: as rotas de documento por codigo exigem
// Authorization, e `<a href target="_blank">` nao manda header nenhum. Um link
// direto ali daria 401 em silencio — a aba abre, e o operador ve JSON de erro.
//
// As rotas do PADRAO (`/v1/prefeitura/folhas/{retorno,movimento}/layout-tecnico`)
// continuam publicas e podem ser linkadas direto; sao especificacao sem dado
// real, feitas pra serem repassadas ao fornecedor do sistema de folha. As de
// codigo nao: o catalogo e' da averbadora, e um rascunho nao pode vazar por link.

/** Busca o documento com o token e abre o blob numa aba. Devolve o erro, se houver. */
export async function abrirDocumentoDeLayout(buscar: () => Promise<Blob>): Promise<string | null> {
  try {
    const blob = await buscar();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank", "noreferrer");
    // Revogar na hora fecharia a aba recem-aberta em alguns navegadores.
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
    return null;
  } catch (e) {
    return (e as Error).message || "Falha ao abrir o documento do layout.";
  }
}
